export default "<div class=\"pinned-menu\">\n    \n</div>"